import React, { useState, useEffect } from 'react';
import ReactPlayer from 'react-player';
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import './matchcss.css';
import axios from "axios";
import { useAuth } from '../../../../../context/AuthContext';

const VideoContent = (props) => {
    const { t } = useTranslation();
    const params = useParams();
    const navigate = useNavigate();
    const [url, setUrl] = useState([]);
    const { user } = useAuth();
    const [subjectName, setSubjectName] = useState("");
    const [msg, setMsg] = useState([]);

    const Request = async (e) => {
        e.preventDefault();
        try {
            await axios.get(
                "https://api.heryerdeingilizce.com/api/user/Content/Answer",
                {
                    params: {
                        questionId: parseInt(props.data.id),
                        answer: "videocontent"
                    },
                    headers: {
                        Authorization: 'Bearer ' + user.token
                    }
                }
            );
            nextquestion();
        } catch (err) {
            nextquestion();
            setMsg(err.message);
        }
    };

    function nextquestion() {
        const n = Number(params.id);
        const newId = n + 1;

        if (newId > props.questionCount) {
            navigate("/user/course/subject");
        } else {
            window.location.href =
                "/user/course/question/" +
                params.subjectid + "/" +
                newId;
        }
    }

    const getSubject = async () => {
        try {
            const res = await axios.get(
                "https://api.heryerdeingilizce.com/api/user/Content/GetSubject",
                {
                    headers: {
                        Authorization: 'Bearer ' + user.token
                    }
                }
            );

            if (res.data.success) {
                setSubjectName(
                    res.data.data.subjects[params.subjectid - 1].subjectName +
                    " - " +
                    res.data.data.subjects[params.subjectid - 1].subjectDesc
                );
            }
        } catch (err) { }
    };

    useEffect(() => {
        getSubject();
        setUrl(props.data.contentStr);
    }, []);

    return (
        <div className="video-page">

            {/* ===== RESPONSIVE CSS (DESKTOP + TABLET + MOBILE) ===== */}
            <style>
                {`
                /* ===== DESKTOP ===== */
                .video-wrapper {
                    position: relative;
                    width: 80%;
                    heigt:80%;
                    padding-top: 45%;
                }

                .video-wrapper .react-player {
                    position: absolute;
                    top: 0;
                    left: 0;
                }

                /* ===== TABLET ===== */
                @media (min-width: 769px) and (max-width: 1024px) {
                    .video-wrapper {
                        width: 90%;
                        padding-top: 50%;
                    }

                    .continue-btn {
                        width: 70%;
                        font-size: 18px;
                        padding: 14px;
                    }

                    .video-page {
                        padding-bottom: 80px;
                    }
                }

                /* ===== MOBILE ===== */
                @media (max-width: 768px) {
                    .video-wrapper {
                        width: 100%;
                        padding-top: 56.25%;
                    }

                    .continue-btn {
                        width: 90%;
                        font-size: 18px;
                        padding: 14px;
                    }

                    .video-page {
                        padding-bottom: 90px;
                    }
                }
                `}
            </style>

            <span style={{ color: "black" }}>
                <b><i>{subjectName}</i></b>
            </span>

            <br /><br />

            {/* ===== VIDEO ===== */}
            <div className="d-flex justify-content-center">
                <div className="video-wrapper">
                    <ReactPlayer
                        className="react-player"
                        url={url}
                        width="100%"
                        height="80%"
                        controls
                        config={{
                            file: {
                                attributes: {
                                    controlsList: "nodownload",
                                    disablePictureInPicture: true
                                }
                            }
                        }}
                    />
                </div>
            </div>

            <br />

            {/* ===== CONTINUE BUTTON ===== */}
            <div className="d-flex justify-content-center" style={{ marginTop: "-10%" }}>
                <button
                    type="button"
                    className="save-btn continue-btn"
                    onClick={Request}
                >
                    {t("continue")}
                </button>
            </div>

        </div>
    );
};

export default VideoContent;
